import { Component, Input, OnInit } from "@angular/core";
import { InspirationRoomService } from "../../../canvas/services/inspiration-rooms/inspiration-room.service";
import { Utilities } from "../../../helpers/utilities";
import { Globals } from "../../../services/globals";
import { SelectionComponent } from "../../selection/selection.component";
import { Option, StyleChoice } from "../../../engine/models/models";
@Component({
  selector: "tile",
  templateUrl: "tile.component.html",
  styleUrls: ['tile.component.css']
})

export class TileComponent {
  @Input() imageUrl: string;
  @Input() name: string;
  @Input() checked: boolean;
  @Input() isMini: boolean;
  @Input() tooltipData: string;
  @Input() parentOptionId: number;
  @Input() childOptionId: number;
  @Input() contractSelectionId: number;
  @Input() isLiked: boolean;
  @Input() isStyle: boolean;
  @Input() isPackage: boolean;
  @Input() price: string;
  @Input() included: boolean;
  @Input() favorited: boolean;
  @Input() needDiscussion: boolean;
  @Input() showprice: boolean;
  @Input() showlabel: boolean;
  @Input() filter = false;
  @Input() filterLabel = "";
  @Input() subLabel = 0;
  @Input() showPersonalizeMeBanner = false;
  @Input() option: Option;
  @Input() style: StyleChoice;
  @Input() disabled: boolean;
  @Input() parentOption: Option;

  get backgroundUrl(): string {
    if (!this.imageUrl) {
      return '/assets/images/image-unavailable.png';
    }
    return this.imageUrl;
  }

  constructor(public globals: Globals,
    private inspirationRoomService: InspirationRoomService,

  ) {
    this.globals.hideHeader = true;
  }

  utilities: Utilities = new Utilities();

  setDefaultImage() {
    this.imageUrl = '/assets/images/image-unavailable.png';
  }

  setAsLiked() {
    if (this.option) {
      this.globals.engine.toggleLiked(this.option);
    } else if (this.isStyle) {
      this.globals.engine.toggleLikedStyle(this.style, this.parentOption);
    }
  }
}
